import { HStack, Text, VStack } from '@chakra-ui/react';
import { appIntl } from '@components/locale/IntlGlobalProvider';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectSituationTime } from '@redux/situation/situation.selectors';
import { formatDate, formatDurationFromTo } from '@utils/date.utils';
import { format } from 'date-fns';

import { DateTimeEnum } from '@/types/dateTime.types';

type Props = {
  startTime: string;
  endTime: string | null;
};

export default function NotificationTimeToast({ startTime, endTime }: Readonly<Props>) {
  const { formatMessage } = appIntl();
  const currentSituationTime = useAppSelector(selectSituationTime);
  const currentDate = new Date(currentSituationTime ?? Date.now());

  const date = formatDate(startTime, DateTimeEnum.DATE);
  const time = format(new Date(startTime), "HH'h'mm");
  const since = formatMessage(
    { id: `notification.${endTime ? 'durationEnded' : 'durationOngoing'}` },
    {
      duration: formatDurationFromTo(startTime, endTime ?? currentDate),
    },
  );

  return (
    <VStack gap={0} alignItems="start">
      <Text fontSize="12px" fontWeight="medium" color="neutral.black" lineClamp={1}>
        {since}
      </Text>
      <HStack gap={1}>
        <Text color="neutral.600" fontSize="12px">
          {date}
        </Text>
        <Text color="neutral.600" fontSize="12px">
          {time}
        </Text>
      </HStack>
    </VStack>
  );
}
